import { motion } from 'framer-motion';

export default function PrivacyPage() {
  return (
    <div className="page-transition" data-testid="privacy-page">
      <section className="py-16 md:py-24 bg-muted/30">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl md:text-5xl font-serif font-semibold text-foreground mb-8">
              Privacy Policy
            </h1>
            <p className="text-muted-foreground mb-4">Last updated: March 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-serif font-semibold mb-4">1. Information We Collect</h2>
            <p className="text-muted-foreground mb-4">
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Name, email address, and phone number when you contact us or subscribe to our newsletter</li>
              <li>Business information when you apply to become a vendor</li>
              <li>Payment information when you register for events or services</li>
              <li>Any other information you choose to provide</li>
            </ul>

            <h2 className="text-2xl font-serif font-semibold mb-4">2. How We Use Your Information</h2>
            <p className="text-muted-foreground mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Communicate about events, updates, and opportunities</li>
            </ul>

            <h2 className="text-2xl font-serif font-semibold mb-4">3. Information Sharing</h2>
            <p className="text-muted-foreground mb-6">
              We do not sell, trade, or rent your personal information to third parties. We may share your information with service providers who assist us in operating our website and conducting our business, provided they agree to keep this information confidential.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">4. Newsletter & Marketing Communications</h2>
            <p className="text-muted-foreground mb-6">
              If you subscribe to our newsletter, you will receive periodic emails about events, artisan features, business tips, and special offers. You may unsubscribe at any time by clicking the "unsubscribe" link in any email or by contacting us directly.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">5. Data Security</h2>
            <p className="text-muted-foreground mb-6">
              We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">6. Cookies and Tracking</h2>
            <p className="text-muted-foreground mb-6">
              Our website may use cookies and similar tracking technologies to enhance your experience. You can set your browser to refuse cookies or alert you when cookies are being sent. However, some features of our website may not function properly without cookies.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">7. Third-Party Links</h2>
            <p className="text-muted-foreground mb-6">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">8. Children's Privacy</h2>
            <p className="text-muted-foreground mb-6">
              Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">9. Your Rights</h2>
            <p className="text-muted-foreground mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-6 space-y-2">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
              <li>Lodge a complaint with a supervisory authority</li>
            </ul>

            <h2 className="text-2xl font-serif font-semibold mb-4">10. Changes to This Policy</h2>
            <p className="text-muted-foreground mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-2xl font-serif font-semibold mb-4">11. Contact Us</h2>
            <p className="text-muted-foreground mb-6">
              If you have any questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:info@artisanmarketandstudio.com" className="text-primary hover:underline">
                info@artisanmarketandstudio.com
              </a>
            </p>

            <div className="mt-12 p-6 bg-muted/50 rounded-xl">
              <p className="text-sm text-muted-foreground">
                © 2026 The Motley Maker LLC. All Rights Reserved. Artisan Market & Studio is a trademark of The Motley Maker LLC.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
